module.exports = __webpack_public_path__ + "static/media/portfolio.a591322c.png";